import _findIndex from "lodash/findIndex";

import {stickyAtcSetZoorixMPromoBadge} from "./sticky-atc/stickyAtc";

export const tabs = [
    {
        id: 'status',
        content: 'Dashboard',
    },
    {
        id: 'products',
        content: 'Offers',
    },
    {
        id: 'settings',
        content: 'Settings',
    },
    {
        id: 'texts',
        content: 'Texts',
    },
    {
        id: 'warranty-moderation',
        content: 'Warranty Mgmt',
    },
    {
        id: 'analytics',
        content: 'ROI',
    },
    {
        id: 'support',
        content: 'Support',
    },
    {
        id: 'manual-installation',
        content: "Installation",
    },
    {
        id: 'faq',
        content: "Tutorials & FAQ",
    },
    {
        id: 'css-editor',
        content: 'Code Editor',
    },
    {
        id: 'integrations',
        content: 'Integrations',
    },
    {
        id: 'plans',
        content: 'Plans',
    },

];

export const integrationTabs = [
    {
        id: 'all',
        content: 'All',
    },
    {
        id: 'page-builders',
        content: 'Page Builders',
    },
];

export const recommendedAppsTabs = [
    {
        id: 'all',
        content: 'All',
    },
    {
        id: 'page-builders',
        content: 'Page Builders',
    },
    /*{
        id: 'translations',
        content: 'Translations',
    },*/
    {
        id: 'videos',
        content: 'Videos',
    },
    {
        id: 'dropshipping',
        content: 'Dropshipping',
    },
    {
        id: 'inventory',
        content: 'Inventory',
    },
    {
        id: 'seo',
        content: 'SEO',
    },
    {
        id: 'billing',
        content: 'Billing',
    },
];

export const recommendedApps = [
    {
        title: 'EComposer',
        description: 'Build any page type or section that is stunning and highly convert',
        badge: 'Page Builder',
        badge_class: 'page-builder-app',
        link: 'https://apps.shopify.com/ecomposer?utm_source=zoorixbundlekit&utm_medium=in-app-integration-page',
        /* icon: 'https://public.zoorix.com/partners/beae-icon.webp', */
        integration: true,
        recommended_app: false,
        page_builder: true,
    },
    {
        title: 'Instant',
        description: 'Build customizable product pages, landing pages, and sections without code',
        badge: 'Page Builder',
        badge_class: 'page-builder-app',
        link: 'https://app.instant.so/?discount=ZOORIX20',
        /* icon: 'https://public.zoorix.com/partners/beae-icon.webp', */
        integration: true,
        recommended_app: false,
        page_builder: true,
    },
    {
        title: 'PageFly',
        description: 'Easily drag & drop Zoorix deals within PageFly’s page builder',
        badge: 'Page Builder',
        badge_class: 'page-builder-app',
        link: 'https://pagefly.io?ref=MkukKDYa&target=app-listing',
        integration: true,
        recommended_app: false,
        page_builder: true,
    },
    // {
    //     title: 'Fiidom – AI AliExpress Dropshipping',
    //     description: 'Discover winning products, optimize listings with AI, and boost sales with smart pricing and marketing insights.',
    //     badge: 'Dropshipping',
    //     badge_class: 'dropshipping-app',
    //     link: 'https://apps.shopify.com/fiidom?utm_source=app-partnership-Zoorix&utm_medium=in-app',
    //     /* icon: 'https://cdn.shopify.com/app-store/listing_images/892c74f790794135de50b41e209ae78e/icon/CJ2bu5GB1ooDEAE=.png', */
    //     integration: false,
    //     recommended_app: true,
    //     page_builder: false,
    //     customer_loyalty: false,
    // },
    // {
    //     "title": "TrackingMore – Order Tracking",
    //     "description": "Enhance order management with real-time tracking, automated notifications, multilingual support, and branded tracking pages to boost customer satisfaction and sales.",
    //     "badge": "Shipping",
    //     "badge_class": "shipping-app",
    //     "link": "https://apps.shopify.com/trackingmore",
    //     /* icon: 'https://cdn.shopify.com/app-store/listing_images/3e1e655db40d47d7b5e4fcf5cf2d0199/icon/CJ2bu5GB1ooDEAE=.png', */ 
    //     "integration": false,
    //     "recommended_app": true,
    //     "page_builder": false,
    //     "customer_loyalty": false
    // },
    {
        title: 'Debutify – AI eCommerce Platform',
        description: "Launch and grow your store with Debutify’s AI - trusted by 10,000+ brands.",
        badge: 'Theme + AI Tools',
        badge_class: 'theme-app',
        link: 'https://debutify.com/theme?ref=zoorix',
        integration: false,
        recommended_app: true,
        page_builder: true,
        inventory: false,
        seo: true,
    },
    {
        title: 'Transtore – Language Translate',
        description: "Translate Your Store and Convert Currency Automatically – Go Global with Ease",
        badge: 'Translation',
        badge_class: 'translation-app',
        link: 'https://apps.shopify.com/transtore-language-and-currency?utm_source=zoorix&utm_medium=partnership&utm_campaign=transtore',
        integration: false,
        recommended_app: true,
        page_builder: false,
        inventory: false,
        seo: false,
    },
    {
        title: 'Loloyal – Loyalty Rewards Refer',
        description: 'Get new customers, cultivate brand fans, and create endless orders with loyalty solutions - Points, Rewards, Referrals, VIP Tiers & more. Enjoy up to 50% off!',
        badge: 'Loyalty & Rewards',
        badge_class: 'customer-loyalty-app',
        link: 'https://share.channelwill.com/app/336645fa5b5d70dOs3',
        /* icon: 'https://cdn.shopify.com/app-store/listing_images/90c0cbb40b9748b853b2851473234440/icon/CPSw5ZS20YoDEAE=.png', */
        integration: false,
        recommended_app: true,
        page_builder: false,
        customer_loyalty: true,
    },
    {
        title: 'Moose: Live Chat WhatsApp, FAQ',
        description: 'Omichannel support with Live chat, SNS, Helpdesk, FAQ & Order Tracking in widget',
        badge: 'Customer Support',
        badge_class: 'customer-support-app',
        link: 'https://apps.shopify.com/moosedesk?utm_source=app-partnership-Zoorix&utm_medium=in-app',
        /* icon: 'https://public.zoorix.com/partners/beae-icon.webp', */
        integration: false,
        recommended_app: true,
        page_builder: false,
        customer_loyalty: true,
    },
    {
        title: 'Checkout Externsion Pro',
        description: 'Powerful Plus-Only App for Checkout Customization, Upsells, and Conversion Optimization',
        badge: 'Checkout',
        badge_class: 'checkout-app',
        link: 'https://apps.shopify.com/checkout-extensions-pro?utm_source=zoorix&utm_medium=in-app-recommended-apps-section',
        /* icon: 'https://public.zoorix.com/partners/beae-icon.webp', */
        integration: false,
        recommended_app: true,
        page_builder: false,
        customer_loyalty: false,
    },
    {
        title: 'Tolstoy',
        description: 'Join 5,000 modern brands driving conversions with Video Commerce',
        badge: 'Videos',
        badge_class: 'videos-app',
        link: 'https://www.gotolstoy.com/ecommerce?utm_medium=app&utm_campaign=partner&utm_source=zoorix',
        integration: false,
        recommended_app: true,
        page_builder: false,
        translation: false,
        video: true,
    },
    {
        title: 'GemPages',
        description: 'Create pages and build up your stores fast to boost sales',
        badge: 'Page Builder',
        badge_class: 'page-builder-app',
        link: 'https://apps.shopify.com/gempages?utm_source=zoorix&utm_medium=referral&utm_campaign=refer-partner',
        integration: true,
        recommended_app: false,
        page_builder: true,
    },
    {
        title: 'Beae',
        description: 'Effortlessly build high-conversion Shopify pages',
        badge: 'Page Builder',
        badge_class: 'page-builder-app',
        link: 'https://apps.shopify.com/beae?utm_source=Partner&utm_medium=Zoorix&utm_campaign=placementinappp',
        /* icon: 'https://public.zoorix.com/partners/beae-icon.webp', */
        integration: true,
        recommended_app: false,
        page_builder: true,
    },
    {
        title: 'Customer Dashboard Pro',
        description: 'Engage with your customers throughout their lifecycle with a beautiful customer account portal',
        badge: 'Customer Loyalty',
        badge_class: 'customer-loyalty-app',
        link: 'https://apps.shopify.com/customer-dashboard-pro?utm_source=zoorix&utm_medium=in-app-recommended-apps-section',
        /* icon: 'https://public.zoorix.com/partners/beae-icon.webp', */
        integration: false,
        recommended_app: true,
        page_builder: false,
        customer_loyalty: true,
    },
    {
        title: 'Fabrikatör',
        description: 'Forecast, plan and execute your inventory operations',
        badge: 'Inventory',
        badge_class: 'inventory-app',
        link: 'https://apps.shopify.com/fabrikator?utm_source=zoorix&utm_medium=zoorix_refs&utm_campaign=zoorix_referral&utm_id=zoorix_referrals',
        integration: false,
        recommended_app: true,
        page_builder: false,
        inventory: true
    },
    {
        title: 'Schema Plus for SEO',
        description: "Boost Your Shopify Store's SEO With The Power of Schema",
        badge: 'SEO',
        badge_class: 'seo-app',
        link: 'https://apps.shopify.com/schema-plus?utm_source=zoorix&utm_medium=partnership&utm_campaign=schemaplus',
        integration: false,
        recommended_app: true,
        page_builder: false,
        inventory: false,
        seo: true,
    },
    {
        title: 'Fordeer: Invoice Order Printer',
        description: "Increase repurchase rate and customers' loyalty with personalized PDF invoices",
        badge: 'Billing',
        badge_class: 'billing-app',
        link: 'https://link.fordeer.io/HN5uHP',
        integration: false,
        recommended_app: true,
        page_builder: false,
        inventory: false,
        seo: false,
        billing: true
    },
    {
        title: 'LangShop',
        description: 'Translate Zoorix widgets and offers using LangShop',
        badge: 'Translation',
        badge_class: 'translation-app',
        link: 'https://apps.shopify.com/langshop?utm_campaign=app-listing&utm_source=app-providers&utm_medium=zoorix&utm_content=in-app',
        /* icon: 'https://public.zoorix.com/images/lang-icon.svg',*/
        integration: false,
        recommended_app: false,
        page_builder: false,
        translation: true,
    },
    {
        title: 'Langify',
        description: 'Translate Zoorix widgets and offers using Langify',
        badge: 'Translation',
        badge_class: 'translation-app',
        link: 'https://apps.shopify.com/langify?utm_campaign=app-listing&utm_source=app-providers&utm_medium=zoorix&utm_content=in-app',
        integration: false,
        recommended_app: false,
        page_builder: false,
        translation: true,
    },
    {
        title: 'Transcy',
        description: 'Translate Zoorix widgets and offers using Transcy',
        badge: 'Translation',
        badge_class: 'translation-app',
        link: 'https://apps.shopify.com/transcy-multiple-languages?utm_campaign=app-listing&utm_source=app-providers&utm_medium=zoorix&utm_content=in-app',
        integration: false,
        recommended_app: false,
        page_builder: false,
        translation: true,
    },
    {
        title: 'WeGlot',
        description: 'Translate Zoorix widgets and offers using WeGlot',
        badge: 'Translation',
        badge_class: 'translation-app',
        link: 'https://apps.shopify.com/weglot?utm_campaign=app-listing&utm_source=app-providers&utm_medium=zoorix&utm_content=in-app',
        integration: false,
        recommended_app: false,
        page_builder: false,
        translation: true,
    },
    {
        title: 'G | Translate',
        description: 'Translate Zoorix widgets and offers using G | Translate',
        badge: 'Translation',
        badge_class: 'translation-app',
        link: 'https://apps.shopify.com/multilingual-shop-by-gtranslate?utm_campaign=app-listing&utm_source=app-providers&utm_medium=zoorix&utm_content=in-app',
        integration: false,
        recommended_app: false,
        page_builder: false,
        translation: true,
    },
    {
        title: 'Translation Lab',
        description: 'Translate Zoorix widgets and offers using Translation Lab',
        badge: 'Translation',
        badge_class: 'translation-app',
        link: 'https://apps.shopify.com/content-translation?utm_campaign=app-listing&utm_source=app-providers&utm_medium=zoorix&utm_content=in-app',
        integration: false,
        recommended_app: false,
        page_builder: false,
        translation: true,
    },
];


export const HANDLE_TAB_CHANGE = 'HANDLE_TAB_CHANGE';
export const CHANGE_INTEGRATIONS_TAB = 'CHANGE_INTEGRATIONS_TAB';
export const CHANGE_RECOMMENDED_APPS_TAB = 'CHANGE_RECOMMENDED_APPS_TAB';
export const ACTIVATE_GENERIC_TOAST = 'ACTIVATE_GENERIC_TOAST';
export const INIT_NAV = 'INIT_NAV';
export const SLIDER_CLICKED = 'SLIDER_CLICKED';
export const BUNDLE_CLICKED = 'BUNDLE_CLICKED';
export const WARRANTY_CLICKED = 'WARRANTY_CLICKED';
export const CART_DRAWER_CLICKED = 'CART_DRAWER_CLICKED';
export const VOLUME_DISCOUNT_CLICKED = 'VOLUME_DISCOUNT_CLICKED';
export const MIX_AND_MATCH_CLICKED = 'MIX_AND_MATCH_CLICKED';
export const BOGO_CLICKED = 'BOGO_CLICKED';
export const DISMISS_GENERIC_TOAST = 'DISMISS_GENERIC_TOAST';
export const APP_CLICKED = 'APP_CLICKED';

export const handleTabChange = tab => ({
    type: HANDLE_TAB_CHANGE,
    tab,
});

export const changeIntegrationsTab = tab => ({
    type: CHANGE_INTEGRATIONS_TAB,
    tab,
});

export const changeRecommendedAppsTab = tab => ({
    type: CHANGE_RECOMMENDED_APPS_TAB,
    tab,
});

export const activateGenericToast = content => ({
    type: ACTIVATE_GENERIC_TOAST,
    content,
});

export const initNav = (json, appType) => ({
    type: INIT_NAV,
    installation: json.installation,
    packageName: json.package_name,
    appType,
});

export const sliderClicked = () => ({
    type: SLIDER_CLICKED,
});

export const bundleClicked = () => ({
    type: BUNDLE_CLICKED,
});

export const warrantyClicked = () => ({
    type: WARRANTY_CLICKED,
});

export const appClicked = () => ({
    type: APP_CLICKED,
});

export const cartDrawerClicked = () => ({
    type: CART_DRAWER_CLICKED,
});

export const volumeDiscountClicked = () => ({
    type: VOLUME_DISCOUNT_CLICKED,
});

export const mixAndMatchClicked = () => ({
    type: MIX_AND_MATCH_CLICKED,
});

export const bogoClicked = () => ({
    type: BOGO_CLICKED,
});

export const dismissGenericToast = () => ({
    type: DISMISS_GENERIC_TOAST,
});

export function changeTab(name) {
    return (dispatch, getState) => {
        const state = getState();
        dispatch(handleTabChange(getTabIndexByName(name, state.nav.tabs)));
    }
}

export function upgradeToZoorixM() {
    return (dispatch, getState) => {
        const state = getState();
        window.open(state.stickyAtc.storeData.upgrade_url, '_blank');
        dispatch(stickyAtcSetZoorixMPromoBadge(false));
    }
}

export function getTabIndexByName(name, tabs) {
    return _findIndex(tabs, { id: name });
}
